<template>
  <div>
    <div class="ui form">
      <div class="field">
        <label for>{{ $t("user finder") }}</label>
        <div class="ui blue search" ref="user_search">
          <div class="ui icon input">
            <input
              class="prompt"
              type="text"
              :placeholder="$t('search user')"
            />
            <i class="search icon"></i>
          </div>
          <div class="results"></div>
        </div>
      </div>
      <div class="field">
        <label for>{{ $t("suscribed users") }}</label>
        <div class="ui very relaxed suscription list">
          <div
            class="ui basic label"
            v-for="(suscription, index) in role.usr_role_suscriptions"
            v-bind:key="suscription.encrypted_id"
          >
            {{ suscription.usr_user.name }}
            <i
              class="red delete icon"
              v-on:click="unsuscribe(suscription, index)"
            ></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, toast } from "@/utils";

export default {
  name: "",
  props: {
    role: Object,
  },
  mounted() {
    let vm = this;
    window.jQuery(this.$refs.user_search).search({
      apiSettings: {
        action: "search user",
        beforeXHR: function(xhr) {
          let token = vm.$session.get("token");
          if (token) {
            xhr.setRequestHeader("x-access-token", token);
          }

          return xhr;
        },
        onResponse: function(response) {
          if (!response.success) toast(vm.$el, "error", response.error);
          else {
            var _response = {
              results: [],
            };
            response.data.map((r) => {
              _response.results.push({
                title: r.name,
                description: r.username,
                user: r,
              });
            });
            return _response;
          }
        },
      },
      onSelect(result) {
        local_api(vm, "post", "/user_role_suscription/do-suscribe", {
          r: vm.role.role_id,
          u: result.user.user_id,
        })
          .then((response) => {
            vm.role.usr_role_suscriptions.push(response);
          })
          .catch((err) => {
            toast(vm.$el, "error", err);
          })
          .finally(() => {
            vm.processing = false;
          });
      },
    });
  },
  methods: {
    unsuscribe(suscription, index) {
      let vm = this;
      this.$alertify.confirm(
        "are you sure to delete suscription?",
        function() {
          local_api(vm, "post", "/user_role_suscription/do-unsuscribe", {
            s: suscription.encrypted_id,
          })
            .then(() => {
              // console.log(response);
              vm.role.usr_role_suscriptions.splice(index, 1);
            })
            .catch((err) => {
              toast(vm.$el, "error", err);
            })
            .finally(() => {
              vm.processing = false;
            });
        },
        function() {},
      );
    },
  },
};
</script>
